import { useDispatch, useSelector } from 'react-redux';
import {
	enableLoading,
	disableLoading,
	setMetaInfo,
	setProperties
} from '../actions';

import axios from 'axios';

const useFilterProperties = () => {
	const dispatch = useDispatch();
	const { filters, urlSearch, url, property_code } = useSelector((state) => ({
		filters: state.properties.filters,
		urlSearch: state.properties.urlSearch,
		url: state.properties.url,
    	property_code: state.properties.property_code
	}));

	const fetchData = async (e) => {
		if (e) {
			e.preventDefault();
		}
		try {
			dispatch(enableLoading());

      const rawMin = filters.price_min ? parseInt(filters.price_min, 10) : 0
      const rawMax = filters.price_max ? parseInt(filters.price_max, 10) : 99999999
      const priceMin = Number.isFinite(rawMin) ? rawMin : 0
      let priceMax = Number.isFinite(rawMax) ? rawMax : 99999999
      if (priceMax && priceMax <= priceMin) {
        priceMax = 99999999
      }

      // Convertir operation_type y property_type a números si existen
      const operationType = filters.operation_type 
        ? (filters.operation_type === '' ? null : parseInt(filters.operation_type, 10))
        : null;
      const propertyType = filters.property_type
        ? (filters.property_type === '' ? null : parseInt(filters.property_type, 10))
        : null;

      const params = {
				price_from: priceMin,
				price_to: priceMax,
				operation_types: operationType && Number.isFinite(operationType)
					? [operationType]
					: [1, 2, 3],
				property_types: propertyType && Number.isFinite(propertyType)
					? [propertyType]
					: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
			};

			if (property_code) {
				const key = '8294000bd1b593b90e40496df1fee0d8aca98af6';
				const codeUrl = `https://tokkobroker.com/api/v1/property/${property_code}/?key=${key}&format=json&lang=es-AR&limit=12`;
				localStorage.setItem("fetchUrl", `${codeUrl}`)
				await axios.get(codeUrl);
        window.location.replace(`/propiedades/${property_code}`)
			} else {
				localStorage.setItem("fetchUrl", `${urlSearch}&data=${JSON.stringify(params)}`)
				const { data } = await axios.get(
					`${urlSearch}&data=${JSON.stringify(params)}`
				);

				dispatch(setProperties(data.objects));
				dispatch(setMetaInfo(data.meta));
			}

			dispatch(disableLoading());
		} catch (error) {
			dispatch(disableLoading());
			console.error('ERROR WHILE FILTERING PROPS: ', error);
      alert('No se encontraron Resultados')
		}
	};

	const fetchAllProperties = async () => {
		try {
			dispatch(enableLoading());
			localStorage.setItem("fetchUrl", `${url}`)
			const { data } = await axios.get(url);
			dispatch(setProperties(data.objects));
			dispatch(setMetaInfo(data.meta));
      dispatch(disableLoading());
		} catch (error) {
			dispatch(disableLoading());
			console.error('ERROR WHILE FETCHING ALL PROPS: ', error);
      alert('No se pudieron cargar las propiedades');
		}
	}

	return { fetchData, fetchAllProperties };
};

export default useFilterProperties;
